// PUT

import axios, { AxiosResponse } from 'axios';
import { MarketId } from 'types/market-id.enum';
import { UpdateDefaultMarketProfileInput } from '../types/update-default-market-profile-input.type';

// /ewosapi/v2/planandprognosis/default-profile/market/{marketId}
export const putDefaultMarketProfile = async (
  marketId: MarketId,
  request: UpdateDefaultMarketProfileInput
): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v2/planandprognosis/default-profile/market/${marketId}`, request);
};
